import { render } from "./BackendNavbarComponent.vue?vue&type=template&id=24159ce5&scoped=true"
import script from "./BackendNavbarComponent.vue?vue&type=script&lang=js"
export * from "./BackendNavbarComponent.vue?vue&type=script&lang=js"

import "./BackendNavbarComponent.vue?vue&type=style&index=0&id=24159ce5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24159ce5"],['__file',"resources/js/components/layouts/backend/BackendNavbarComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24159ce5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24159ce5', __exports__)) {
    api.reload('24159ce5', __exports__)
  }
  
  module.hot.accept("./BackendNavbarComponent.vue?vue&type=template&id=24159ce5&scoped=true", () => {
    api.rerender('24159ce5', render)
  })

}


export default __exports__